import { render, staticRenderFns } from "./TruckDetail.vue?vue&type=template&id=53f45968&scoped=true"
import script from "./TruckDetail.vue?vue&type=script&lang=js"
export * from "./TruckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f45968",
  null
  
)

export default component.exports